import React from "react";
import { Box} from "@mui/material";

const TopBreadcrumb = ({ title }) => {
  return (
    <Box
      sx={{
        padding: "40px 0",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& ul": {
          padding: 0,
        },
        "& .TopBreadcrumbList li": {
          display: "inline-flex",
          alignItems: "center",
          fontSize: "14px",
          lineHeight: "21px",
          fontWeight: "400",
          fontFamily: `"Quicksand", sans-serif`,
        },
        "& .TopBreadcrumbList li a": {
          color: "#253D4E",
        },
        "& .TopBreadcrumbList li span": {
          margin: "0 7px",
        },
        "& .TopBreadcrumbList li.active a": {
          color: "#000",
          display: "flex",
          alignItems: "center",
          textDecoration: "none",
        },
      }}
    >
      <div>
        <ul className="TopBreadcrumbList">
          <li>
            <a href="/">
              Home <span>/</span>
            </a>
          </li>
          <li className="active">My Account</li>
        </ul>
      </div>
    </Box>
  );
};

export default TopBreadcrumb;
